/**
 * 分页查询混入
 * 组件必须有一个listLoad方法用来加载列表数据
 */
const pagingMixin = {
  data: function() {
    return {
      listQuery: {
        pageNum: 1,
        pageSize: 10
      },
      collapse: false
    }
  },
  /**
   * 组件挂载自动查询
   */
  created() {
    if (!this.$options.doNotInit) {
      this.listLoad()
    }
  },
  methods: {
    /**
     * 处理查询
     */
    handleFilter() {
      this.listQuery.pageNum = 1
      this.listQuery.orderfield && (this.listQuery.orderfield = '')
      this.listLoad()
    },
    /**
     * 处理分页大小改变
     * @param {number} value - 分页大小
     */
    handleSizeChange(value) {
      this.listQuery.pageNum = 1
      this.listQuery.pageSize = value
      this.listLoad()
    },
    /**
     * 处理页码改变
     * @param {number} value - 页码
     */
    handleCurrentChange(value) {
      this.listQuery.pageNum = value
      this.listLoad()
    },
    /**
     * 处理数据清空
     */
    handleClear() {
      for (const k in this.listQuery) {
        if (k === 'pageNum' || k === 'pageSize') {
          continue
        } else {
          this.listQuery[k] = ''
        }
      }
    },
    /**
     * 处理展开收起
     * @param {*} e
     */
    handleCollapse(e) {
      this.collapse = e
    },
    sortChange(row) {
      const direction = row.order
      if (direction === null) {
        return
      }
      this.listQuery.pageNum = 1
      // 驼峰转连字符
      // const propNames = row.prop.replace(/([A-Z])/g, '_$1').toLowerCase()
      this.listQuery.orderField = row.prop
      this.listQuery.direction = direction.replace(/ending/, '')
      this.listLoad()
    },
    setOrderField(orderStr, targetTable) {
      if (orderStr) {
        const orderfieldList = orderStr.split(',')
        orderfieldList.forEach(item => {
          const index = targetTable.findIndex(v => {
            return v.prop === item
          })
          if (index > -1) {
            this.$set(targetTable[index], 'sortable', 'custom')
          }
        })
      }
    }
  }
}
export {
  pagingMixin
}
